import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const STORAGE_KEY = "sx_promo_by_chart_id_v1";

export default function UnlockPage() {

  const [params] = useSearchParams();
  const navigate = useNavigate();

  const code = params.get("code");
  const chartId = params.get("chart_id");
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {

    const activate = async () => {

      if (!code || !chartId) {
        alert("Invalid activation link.");
        return;
      }

      try {

        const res = await fetch(`${API_BASE}/promo/verify`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            code: code,
            chart_id: chartId
          })
        });

        const data = await res.json();

        if (!data.ok) {

          if (data.error === "USAGE_LIMIT_EXCEEDED") {
            navigate(`/chart?chart_id=${chartId}`);
            return;
          }

          alert("Activation failed: " + data.error);
          return;
        }

        // Save promo locally
        const entry = {
          code: code,
          plan: data.plan,
          expires_at: data.expires_at,
          uses_count: data.uses_count,
          max_uses: data.max_uses
        };

        let store: Record<string, any> = {};

        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          const parsed = raw ? JSON.parse(raw) : {};
          if (parsed && typeof parsed === "object") {
            store = parsed;
          }
        } catch {}

        store[chartId] = entry;

        localStorage.setItem(STORAGE_KEY, JSON.stringify(store));

        // 🔥 IMPORTANT: force backend recalculation for Growth content
        await fetch(`${API_BASE}/calculate`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            chart_id: chartId
          })
        });

        // Redirect
        navigate(`/chart?chart_id=${chartId}`);

      } catch (err) {
        alert("Network error while activating access.");
      }

    };

    activate();

  }, [navigate, code, chartId, API_BASE]);

  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h2>Activating your access...</h2>
      <p>Please wait while we unlock your plan.</p>
    </div>
  );
}
